@if (isAvailable) {
  <app-async-mat-icon-button
    [ariaLabel]="ariaLabel()"
    [title]="ariaLabel()"
    [action]="action"
    progress="bar"
    (actionResult)="actionResult.emit($event)"
  >
    <mat-icon svgIcon="yousign"></mat-icon>
  </app-async-mat-icon-button>
}
